import { useParams } from 'react-router-dom'
import { SellerDelivery as SellerDeliveryComponent } from 'components/sellers/SellerDelivery/SellerDelivery'

export const SellerDelivery: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerDeliveryComponent type='seller' sellerId={id as string} />
}